import { render, staticRenderFns } from "./giftsPopup.vue?vue&type=template&id=0be0be8b&scoped=true&"
import script from "./giftsPopup.vue?vue&type=script&lang=js&"
export * from "./giftsPopup.vue?vue&type=script&lang=js&"
import style0 from "./giftsPopup.vue?vue&type=style&index=0&id=0be0be8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0be8b",
  null
  
)

export default component.exports